/**
 * The resize grip: one soft arc, concentric with the window's corner (centre
 * 6,6, radius 13 in its box). The arc's reach and weight live in window.css,
 * so resting and hovered geometry are tuned in one place.
 */
export function GripArc() {
  return (
    <svg className="grip-arc" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M18.9 7.58A13 13 0 0 1 7.58 18.9" />
    </svg>
  );
}
